// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentModel {
    static getAttributeTypeMap() {
        return DocumentModel.attributeTypeMap;
    }
}
DocumentModel.discriminator = undefined;
DocumentModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "documentGroupId",
        "baseName": "documentGroupId",
        "type": "number"
    },
    {
        "name": "displayId",
        "baseName": "displayId",
        "type": "string"
    },
    {
        "name": "documentGroupSource",
        "baseName": "documentGroupSource",
        "type": "DocumentGroupSource"
    },
    {
        "name": "documentGroupReceivedDate",
        "baseName": "documentGroupReceivedDate",
        "type": "Date"
    },
    {
        "name": "documentOriginalFileName",
        "baseName": "documentOriginalFileName",
        "type": "string"
    },
    {
        "name": "documentPageCount",
        "baseName": "documentPageCount",
        "type": "number"
    },
    {
        "name": "documentFileName",
        "baseName": "documentFileName",
        "type": "string"
    },
    {
        "name": "documentLocation",
        "baseName": "documentLocation",
        "type": "string"
    },
    {
        "name": "documentLayoutCode",
        "baseName": "documentLayoutCode",
        "type": "string"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "lastUpdatedBy",
        "baseName": "lastUpdatedBy",
        "type": "number"
    },
    {
        "name": "lastUpdateDate",
        "baseName": "lastUpdateDate",
        "type": "Date"
    },
    {
        "name": "childDocumentLinks",
        "baseName": "childDocumentLinks",
        "type": "Array<DocumentLinkModel>"
    },
    {
        "name": "parentDocumentLinks",
        "baseName": "parentDocumentLinks",
        "type": "Array<DocumentParentLinkModel>"
    },
    {
        "name": "documentTypeId",
        "baseName": "documentTypeId",
        "type": "number"
    },
    {
        "name": "documentStatus",
        "baseName": "documentStatus",
        "type": "DocumentStatus"
    },
    {
        "name": "documentGroupStatus",
        "baseName": "documentGroupStatus",
        "type": "DocumentGroupStatus"
    },
    {
        "name": "faxAni",
        "baseName": "faxAni",
        "type": "string"
    },
    {
        "name": "faxDns",
        "baseName": "faxDns",
        "type": "string"
    },
    {
        "name": "intakeLayoutId",
        "baseName": "intakeLayoutId",
        "type": "number"
    }
];
//# sourceMappingURL=documentModel.js.map